import {
  clientIdByPortalAndMode,
  entraBaseUrlByMode,
  entraSharedParams,
  tenantIdByEnv,
  EntraPortalType,
  EntraRuntimeMode,
  redirectUriByPortalAndMode,
} from './EntraRedirects.ts';

export const buildEntraLoginUrl = (portalType: EntraPortalType, mode: EntraRuntimeMode) => {
  const baseUrl = entraBaseUrlByMode[mode]?.trim();
  const tenantId = tenantIdByEnv?.[mode]?.trim();
  const clientId = clientIdByPortalAndMode[mode]?.[portalType]?.trim();
  const redirectUri = redirectUriByPortalAndMode[portalType]?.[mode]?.trim();

  if (!baseUrl || !tenantId || !clientId || !redirectUri) {
    console.error(`Missing Entra configuration for ${portalType} in ${mode}`);
    return null;
  }

  try {
    const url = new URL(`${baseUrl}/${tenantId}/oauth2/v2.0/authorize`);
    url.searchParams.set('client_id', clientId);
    url.searchParams.set('redirect_uri', redirectUri);
    url.searchParams.set('scope', entraSharedParams.scope);
    url.searchParams.set('response_type', entraSharedParams.response_type);
    if(portalType === 'admin'){
      url.searchParams.set('prompt', entraSharedParams.prompt_admin);
    }else if(portalType === 'dealer'){
      url.searchParams.set('prompt', entraSharedParams.prompt_dealer);
    }
    url.searchParams.set('nonce', entraSharedParams.nonce);
    return url.toString();
  } catch (error) {
    console.error(`Invalid Entra configuration for ${portalType} in ${mode}`, error);
    return null;
  }
};
